import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Floor} from '../../../afb-api/models/floor';
import {HorizontalAlignment} from '../../../vision/dropdown/enums/dropdown.enum';

@Component({
  selector: 'awair-floor-list',
  templateUrl: './floor-list.component.html',
  styleUrls: ['./floor-list.component.scss']
})

export class FloorListComponent implements OnInit {

  @Input() floors: Floor[] = [];
  @Input() selectedFloorId: string;
  @Input() canDelete: boolean = false;
  @Output() selectFloor: EventEmitter<string> = new EventEmitter<string>();
  @Output() deleteFloor: EventEmitter<Floor> = new EventEmitter<Floor>();

  HorizontalAlignment = HorizontalAlignment;

  constructor() {
  }

  ngOnInit() {
  }

  onSelectFloor(floorId: string): void {
    this.selectFloor.emit(floorId);
  }

  onDeleteFloor(floor: Floor): void {
    this.deleteFloor.emit(floor);
  }
}
